import React from 'react';
import { FDPaper, FDStack } from '@facet-wealth/design';

const MemberDemographics = () => {
  // TODO: Once member demographics is designed, conditionally render based on relationship (uncomment below)
  // const { pageContentResource: memberDashboardResource } = usePageContentContext();
  // const memberDemographics = relationship.getRelated();
  // const { shouldRenderMemberDemographics, memberDemographicsRelationship } = memberDashboardResource.withRelationship(
  //   fr.relationships.memberDemographics.name,
  //   (rel) => ({ shouldRenderMemberDemographics: true, memberDemographicsRelationship: rel }),
  //   () => ({ shouldRenderMemberDemographics: false }),
  // );
  return (
    <FDPaper appearance={'flat'}>
      <FDStack height={140} width={'100%'} alignItems={'center'} justifyContent={'center'}>
        {'Member Demographics'}
      </FDStack>
    </FDPaper>
  );
};

MemberDemographics.defaultProps = {};

MemberDemographics.propTypes = {};

export { MemberDemographics };
